import React from 'react';
import { SocialShareLink } from '../../get-data/transform/share-links';
import ShareLink from './share-link';
import { SharePanelItems } from './style';

const Items: React.FC<Props> = ({ items }) => (
    <SharePanelItems data-q="share-panel">
        {items.map((props, index) => (
            // eslint-disable-next-line react/no-array-index-key
            <li key={index}>
                <ShareLink {...props} />
            </li>
        ))}
    </SharePanelItems>
);

interface Props {
    items: SocialShareLink[];
}

Items.defaultProps = {
    items: [],
};

export default Items;
